var _defs, _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKarnovLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 187.53 65.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#222221;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "KG_logo_BLACK_Vector") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25.14,
    y: 0.37,
    width: 4.92,
    height: 34.76
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.08,
    y: 0.37,
    width: 4.92,
    height: 34.76
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.02,
    y: 0.37,
    width: 4.92,
    height: 34.76
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.96,
    y: 0.37,
    width: 4.92,
    height: 34.76
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.47,240.09a8.32,8.32,0,0,1-5.92-2.43c-2.21-2.21-2.21-4.46-2.21-9.4s0-7.19,2.21-9.4a8.32,8.32,0,0,1,5.92-2.43c3.11,0,5,1.3,7,3.24l0.35,0.35L219,221.87l-0.35-.35c-1.78-1.78-2.95-2.58-5.16-2.58a5.42,5.42,0,0,0-3.87,1.57c-1.45,1.45-1.57,3.08-1.57,7.75s0.12,6.3,1.57,7.75a5.4,5.4,0,0,0,3.87,1.57,5.46,5.46,0,0,0,4.25-2,5.92,5.92,0,0,0,1.23-4.09V230h-6v-2.5h8.67v4.13a7.69,7.69,0,0,1-1.95,5.72,8.38,8.38,0,0,1-6.22,2.73h0Z",
    transform: "translate(-205.33 -174.87)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.24,240.09c-4.79,0-8.14-3.25-8.14-7.92V216.62h2.69V232c0,3.42,2.14,5.63,5.45,5.63s5.45-2.21,5.45-5.63V216.62h2.69v15.55c0,4.66-3.35,7.92-8.14,7.92h0Z",
    transform: "translate(-205.33 -174.87)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.17,240.09a8.31,8.31,0,0,1-5.92-2.43c-2.21-2.21-2.21-4.46-2.21-9.4s0-7.19,2.21-9.4a8.44,8.44,0,0,1,11.85,0c2.21,2.21,2.21,4.46,2.21,9.4s0,7.19-2.21,9.4a8.31,8.31,0,0,1-5.92,2.43h0Zm0-21.15a5.42,5.42,0,0,0-3.87,1.57c-1.45,1.45-1.57,3.08-1.57,7.75s0.12,6.3,1.57,7.75a5.54,5.54,0,0,0,7.74,0c1.45-1.45,1.57-3.08,1.57-7.75s-0.12-6.3-1.57-7.75a5.42,5.42,0,0,0-3.87-1.57h0Z",
    transform: "translate(-205.33 -174.87)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.17,229.46a6.17,6.17,0,0,0,4.88-6.36c0-3.93-2.7-6.48-6.88-6.48h-9v23.28h2.69V219.13H233c2.8,0,4.41,1.46,4.41,4,0,3.49-2.77,4-4.41,4H232.2v2.5h0l5.32,10.26h3.1Z",
    transform: "translate(-205.33 -174.87)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.8,216.62h-8.67v23.28h2.69V219.13h5.79c1.76,0,4.72.57,4.72,4.41s-3,4.41-4.72,4.41h-3v2.5h3.15c4.32,0,7.23-2.78,7.23-6.91S296.12,216.62,291.8,216.62Z",
    transform: "translate(-205.33 -174.87)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.92,210.33h-3.36l-19-28.56v28.56H312V175.16h3.36l19,28.47V175.16h3.59v35.18h0Z",
    transform: "translate(-205.33 -174.87)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M353.85,210.62a12.09,12.09,0,0,1-8.66-3.41c-3.38-3.38-3.55-6.36-3.55-14.47s0.17-11.08,3.55-14.47a12.7,12.7,0,0,1,17.32,0c3.38,3.38,3.55,6.36,3.55,14.47s-0.17,11.08-3.55,14.47a12.1,12.1,0,0,1-8.66,3.41h0Zm0-32.45a8.37,8.37,0,0,0-6.13,2.49c-2.29,2.29-2.49,5-2.49,12.08s0.2,9.79,2.49,12.08a8.77,8.77,0,0,0,12.25,0c2.29-2.29,2.49-5,2.49-12.08S362.26,183,360,180.67a8.37,8.37,0,0,0-6.13-2.49h0Z",
    transform: "translate(-205.33 -174.87)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M381.3,210.33h-2.93l-0.11-.34L366.8,175.16h3.79l9.24,28.5,9.24-28.5h3.79L381.3,210.33h0Z",
    transform: "translate(-205.33 -174.87)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.65,194.4a9.25,9.25,0,0,0,7.62-9.58c0-5.87-4-9.67-10.29-9.67H284.47v35.18h3.59V178.46h9.58c2.63,0,7,.83,7,6.41s-4.41,6.41-7,6.41h-1v3.3h0l8.16,15.75H309Z",
    transform: "translate(-205.33 -174.87)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "65.41 0.29 62.41 0.29 49.46 35.47 53.32 35.47 63.91 5.74 74.5 35.47 78.36 35.47 65.41 0.29"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "49.77 0.29 44.99 0.29 32.06 17.87 46.84 35.47 48.27 35.47 49.29 32.67 36.86 17.82 49.77 0.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKarnovLogo);
export default __webpack_public_path__ + "static/media/KarnovLogo.a6503e7dfc48c5b491f4f55c37ed2532.svg";
export { ForwardRef as ReactComponent };